"use client";

import { c as _c } from "react/compiler-runtime";
import { FunctionComponent } from "react";
import ROUTES from "@app/routes";
import Link from "@components/navigation/link";
import { MainButton } from "@components/ui-kit/elements/buttons/main-button/main-button";
import styles from "./error.module.scss";
const ErrorPageView: FunctionComponent = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className={styles.container}><MainButton component={Link} href={ROUTES.HOME}>На главную</MainButton></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
export default ErrorPageView;